export default __webpack_public_path__ + "static/media/special-rare.d574d4b6.png";